module.exports = __webpack_public_path__ + "static/media/IMG-9.c3ad5e0c.jpg";